import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { ButtonGroup, Button } from 'reactstrap'
import { FaTrash } from 'react-icons/lib/fa'
import ImageModal from './ImageModal'
import { hasImage } from './ImageSlatePluginContainer'
import { deleteInlineImage } from './ImageUtils'
import styles from './ImageSlatePlugin.scss'
import EditorTooltip from '../EditorTooltip'
import classNames from 'classnames'

class ImageNode extends Component {
  constructor (props) {
    super(props)
    this.state = { isModalActive: false, isTooltipOpen: false, loaded: false, error: false }

    const { node: { key } } = props
    this.uid = `image-node-key${key}-${Date.now()}`
  }

  modal = (isModalActive) => {
    this.setState({ isModalActive })
  }

  onRemove = () => {
    const { state, editor: { onChange } } = this.props
    return onChange(deleteInlineImage({ state }))
  }

  isTooltipOpen = () => {
    const { isModalActive } = this.state
    const { node, state } = this.props
    return !isModalActive && hasImage(state, node.key)
  }

  handleImageLoaded = e => {
    if (!this.state.loaded) {
      this.setState({
        loaded: true
      })
    }
  }

  handleImageError = e => {
    this.setState({
      error: true
    })
  }

  render () {
    const { isModalActive, loaded, error } = this.state
    const { node, state, attributes, editor: { onChange } } = this.props
    const isTooltipOpen = this.isTooltipOpen()
    const isInvalidFile = !node.data.get('fileId')
    const maxWidth = node.data.get('maxWidth')
    const imageStyle = {}
    if (maxWidth) {
      imageStyle.maxWidth = maxWidth + 'px'
    }

    return (
      <span>
        <ImageModal
          isOpen={isModalActive}
          node={node}
          state={state}
          onChange={onChange}
          changeModalState={this.modal}
          />
        <div id={this.uid}
          className={classNames(styles.imageHolder,
            {
              [styles.invalidFile]: isInvalidFile,
              [styles.imageError]: error,
              [styles.imageNotLoaded]: !loaded
            })} >

          <EditorTooltip state={state} placement='top' isOpen={isTooltipOpen} target={this.uid} toggle={this.toggle}>
            <div>
              <div>
                {node.data.get('title')}
                <div><a href={node.data.get('src')} target='_blank'>Open image in new tab</a></div>
                {node.data.get('href') && <div>Link <a href={node.data.get('href')} target='_blank'>{node.data.get('href')}</a></div>}
                {node.data.get('href') && <div>Link opens in <strong>{node.data.get('openExternal') ? 'new tab' : 'same tab'}</strong></div>}
              </div>

              <ButtonGroup style={{marginTop: '10px'}}>
                <Button onClick={() => {
                  this.modal(true)
                }}>
                  Edit
                </Button>
                <Button color='danger' onClick={this.onRemove}>
                  <FaTrash />
                </Button>
              </ButtonGroup>
            </div>
          </EditorTooltip>

          {
            (!loaded || error) &&
            <div>
              <a href={node.data.get('src')} target='_blank'>
                {error && '⚠️ Error '}loading image ...
              </a>
            </div>
          }

          <img
            {...attributes}
            role='presentation'
            style={imageStyle}
            onError={this.handleImageError}
            onLoad={this.handleImageLoaded}
            src={node.data.get('src')}
            alt={node.data.get('title') || node.data.get('src')}
            title={node.data.get('title') || node.data.get('src')}
          />

        </div>
      </span>
    )
  }
}

ImageNode.propTypes = {
  node: PropTypes.shape({
    data: PropTypes.shape({
      get: PropTypes.func.isRequired
    }),
    get: PropTypes.func.isRequired
  }),
  state: PropTypes.object,
  editor: PropTypes.object,
  attributes: PropTypes.object
}

export default ImageNode



// WEBPACK FOOTER //
// ./src/components/ImageSlatePlugin/ImageNode.js